<template>
  <div class="full-height">
    <login-header></login-header>
    <intro></intro>
    <section-intro title="Log In"></section-intro>

    <div>
      <login-form></login-form>
    </div>

    <login-footer></login-footer>
  </div>
</template>

<script>
  import Intro from '@/components/partials/IntroLarge'
  import LoginHeader from '@/components/partials/Header'
  import LoginFooter from '@/components/partials/Footer'
  import LoginForm from '@/components/forms/LoginForm'
  import SectionIntro from '@/components/partials/SectionIntro'

  export default {
    components: {
      LoginHeader,
      LoginFooter,
      Intro,
      LoginForm,
      SectionIntro
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?378751e1